/*!
 * Dalafisk – recipe index sorting
 * ------------------------------------------------------------------
 * Reorders the rendered recipe cards. The section only emits the control when
 * every article is on one page (see dalafisk-recipe-grid.liquid), so what is on
 * screen is the whole set and this is never a partial sort presented as a full
 * one.
 *
 * Shopify blogs have no sort_by and Liquid cannot read a query string, so this
 * cannot be done on the server. Sort keys come from data attributes the section
 * renders; nothing is parsed out of the visible text.
 *
 * Progressive: with the script absent the cards keep the blog's own order and
 * the select simply does nothing — no content is hidden or reordered up front.
 */
(function () {
  'use strict';

  if (window.__dalafiskRecipeSort) return;
  window.__dalafiskRecipeSort = true;

  function keyOf(card, mode) {
    var raw = card.getAttribute('data-sort-' + mode);
    if (mode === 'namn') return (raw || '').toLocaleLowerCase('sv');
    var n = parseFloat(raw);
    return isNaN(n) ? -1 : n;
  }

  function sortCards(list, mode) {
    var cards = Array.prototype.slice.call(list.querySelectorAll('.dalafisk-recipe-card'));

    cards.sort(function (a, b) {
      var ka = keyOf(a, mode);
      var kb = keyOf(b, mode);

      if (mode === 'namn') return ka.localeCompare(kb, 'sv');

      /* -1 means the article has no value for this key. Those go last whichever
         direction the sort runs, so an unfilled recipe never claims to be the
         fastest or the one with the most items. */
      if (ka < 0 && kb < 0) return 0;
      if (ka < 0) return 1;
      if (kb < 0) return -1;

      /* Newest first and most items first are descending; fastest is ascending. */
      return mode === 'snabb' ? ka - kb : kb - ka;
    });

    var frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(c); });
    list.appendChild(frag);
  }

  function init() {
    var select = document.querySelector('[data-dalafisk-recipe-sort]');
    if (!select) return;
    var list = document.querySelector('.dalafisk-recipe-grid__list');
    if (!list) return;

    select.addEventListener('change', function () {
      sortCards(list, select.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
